module.exports = __webpack_public_path__ + "img/smart0.a10a22ef.png";